var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagUru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2111 3495)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_435",
    "data-name": "Ret\\xE2ngulo 435",
    width: 102.84,
    height: 59.985,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_URU",
    transform: "translate(-2111 -3495)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_uruguai",
    transform: "translate(2111 3495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_434",
    "data-name": "Ret\\xE2ngulo 434",
    width: 102.84,
    height: 59.985,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6177",
    "data-name": "Caminho 6177",
    d: "M113.611,50.541h102.84V43.874H113.611Zm0-13.327h102.84V30.541H113.611Zm33.341-13.334h69.5V17.217h-69.5Zm0-13.334h69.5V3.887h-69.5Z",
    transform: "translate(-113.611 2.777)",
    fill: "#3e73b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_781",
    "data-name": "Grupo 781",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_780",
    "data-name": "Grupo 780",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6178",
    "data-name": "Caminho 6178",
    d: "M125.338,9.748l.293,4.922c-4.545,3.286-1.738,5.218-5.03,6.281,2.224-2.217-.674-2.217,1.834-7.248",
    transform: "translate(-108.618 6.963)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6179",
    "data-name": "Caminho 6179",
    d: "M125.6,9.749l.286,4.922h-.2l-.382-4.922Zm.286,4.922h0v.1l-.094-.1Zm0,.1a6.487,6.487,0,0,0-3,4.058h-.293a6.829,6.829,0,0,1,3.094-4.255Zm-3,4.058a2.52,2.52,0,0,1-2.028,2.22l-.1-.2a2.258,2.258,0,0,0,1.833-2.023Zm-2.028,2.22-.485.189.293-.286h.094Zm-.192-.1c.967-1.063.967-1.644.77-2.415h.293a2.486,2.486,0,0,1-.871,2.513Zm.77-2.415a7.267,7.267,0,0,1,1.068-4.833l.192.1c-1.26,2.609-1.159,3.766-.967,4.733Z",
    transform: "translate(-108.78 6.964)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6180",
    "data-name": "Caminho 6180",
    d: "M123.791,11.984a10.969,10.969,0,0,0-1.545,4.833l-.29-.1a13.226,13.226,0,0,1,1.646-4.833Zm-1.545,4.833c-.192,1.257-.389,2.22-1.546,2.705l-.1-.2c1.065-.48,1.157-1.356,1.356-2.6Z",
    transform: "translate(-108.618 8.492)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6181",
    "data-name": "Caminho 6181",
    d: "M123.525,14.457l-.386-5.026c4.539-3.283,1.742-5.222,5.026-6.276-2.133,2.316.679,2.316-1.838,7.245",
    transform: "translate(-106.805 2.254)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6182",
    "data-name": "Caminho 6182",
    d: "M123.372,14.539l-.288-4.929.192-.1.389,5.026Zm-.288-4.929v-.1h.093Zm0-.1c2.409-1.738,2.794-3.086,2.986-4.15l.3.093c-.3,1.063-.679,2.417-3.091,4.155Zm2.986-4.15a2.626,2.626,0,0,1,2.035-2.227l.1.2a2.281,2.281,0,0,0-1.836,2.124Zm2.035-2.227.485-.1-.293.291-.094-.094Zm.192.2c-.967,1.061-.967,1.546-.77,2.321l-.293.1a2.621,2.621,0,0,1,.871-2.613Zm-.77,2.321c.089.963.286,2.22-1.068,4.922l-.192-.093c1.26-2.609,1.159-3.866.967-4.733Z",
    transform: "translate(-106.845 2.172)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6183",
    "data-name": "Caminho 6183",
    d: "M124.21,10.63A13.175,13.175,0,0,0,125.852,5.9h.192A12.8,12.8,0,0,1,124.4,10.73ZM125.852,5.9c.192-1.346.29-2.22,1.449-2.8l.1.2c-1.065.482-1.166,1.354-1.354,2.606Z",
    transform: "translate(-106.04 2.212)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6184",
    "data-name": "Caminho 6184",
    d: "M128.074,11.722l-5.026.288c-3.279-4.539-5.217-1.738-6.278-5.025,2.318,2.223,2.22-.581,7.243,1.838",
    transform: "translate(-111.355 4.99)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6185",
    "data-name": "Caminho 6185",
    d: "M128.194,11.937l-5.026.386v-.29l4.93-.293Zm-5.026.386h0l-.1-.093.1-.1Zm-.1-.093a6.058,6.058,0,0,0-4.054-2.995v-.2c1.157.293,2.513.581,4.248,3.094Zm-4.054-2.995a2.61,2.61,0,0,1-2.223-2.026l.19-.1a2.524,2.524,0,0,0,2.033,1.929Zm-2.223-2.026-.192-.393.382.291h-.094Zm.19-.1a2.288,2.288,0,0,0,2.323.771l.093.194a2.614,2.614,0,0,1-2.606-.864Zm2.323.771c.96-.192,2.224-.386,4.929.967l-.2.19c-2.606-1.25-3.77-1.061-4.637-.963Z",
    transform: "translate(-111.475 4.869)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6186",
    "data-name": "Caminho 6186",
    d: "M124.251,10.271a11.355,11.355,0,0,0-4.737-1.641v-.3a11.879,11.879,0,0,1,4.833,1.738Zm-4.737-1.641c-1.356-.2-2.22-.386-2.8-1.545l.192-.1c.485,1.065,1.353,1.26,2.609,1.349Z",
    transform: "translate(-111.395 4.99)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6187",
    "data-name": "Caminho 6187",
    d: "M123.364,9.91l4.93-.389c3.279,4.539,5.217,1.834,6.276,5.025-2.316-2.131-2.224.675-7.241-1.841",
    transform: "translate(-106.645 6.801)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6188",
    "data-name": "Caminho 6188",
    d: "M123.308,9.846l5.026-.382v.194l-4.93.387Zm5.026-.382h.1l-.1.1Zm.1,0c1.641,2.417,2.995,2.8,4.054,3.094v.189c-1.157-.29-2.513-.67-4.251-3.089Zm4.054,3.094a2.371,2.371,0,0,1,2.223,2.028h-.192a2.285,2.285,0,0,0-2.031-1.839Zm2.223,2.028.192.389-.384-.293.094-.1Zm-.192.1a2.233,2.233,0,0,0-2.321-.775l-.1-.192a2.362,2.362,0,0,1,2.609.77Zm-2.321-.775a7.241,7.241,0,0,1-4.826-1.059l.089-.194c2.612,1.353,3.773,1.154,4.641,1.061Z",
    transform: "translate(-106.685 6.76)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6189",
    "data-name": "Caminho 6189",
    d: "M125.6,10.592a12.848,12.848,0,0,0,4.833,1.642l-.1.194a11.76,11.76,0,0,1-4.833-1.642Zm4.833,1.642c1.257.194,2.124.285,2.705,1.546l-.192.1c-.485-1.161-1.353-1.253-2.609-1.449Z",
    transform: "translate(-105.115 7.566)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6190",
    "data-name": "Caminho 6190",
    d: "M128.074,9.748l-3.283,3.765c-5.6-.97-5.023,2.421-8.021.871,3.189-.1,1.161-2.03,6.375-3.866",
    transform: "translate(-111.355 6.963)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6191",
    "data-name": "Caminho 6191",
    d: "M128.275,9.792l-3.19,3.765-.19-.1,3.285-3.773Zm-3.19,3.765-.091.093v-.093Zm-.091.093c-2.9-.485-4.157.2-5.025.778l-.2-.192c.963-.586,2.222-1.356,5.222-.874Zm-5.025.778a2.7,2.7,0,0,1-3.094.1l.1-.2a2.39,2.39,0,0,0,2.8-.089Zm-3.094.1-.389-.2h.485v.1Zm.1-.2a2.276,2.276,0,0,0,2.22-1.161l.2.2a2.384,2.384,0,0,1-2.417,1.162Zm2.22-1.161c.581-.766,1.353-1.733,4.157-2.7l.1.194c-2.8.967-3.579,1.93-4.058,2.705Z",
    transform: "translate(-111.557 6.92)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6192",
    "data-name": "Caminho 6192",
    d: "M124.307,10.786A12.268,12.268,0,0,0,119.767,13l-.1-.189a12.279,12.279,0,0,1,4.545-2.223ZM119.767,13c-1.068.778-1.745,1.356-3,.874v-.2c1.161.389,1.834-.089,2.9-.864Z",
    transform: "translate(-111.355 7.565)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6193",
    "data-name": "Caminho 6193",
    d: "M123.364,11.893l3.187-3.77c5.6.871,5.023-2.513,8.02-.967-3.185.1-1.159,2.127-6.377,3.866",
    transform: "translate(-106.645 4.819)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6194",
    "data-name": "Caminho 6194",
    d: "M123.307,11.819l3.19-3.765.192.2-3.286,3.67Zm3.19-3.765h.093v.1Zm.093,0a6.6,6.6,0,0,0,5.025-.766l.19.189c-.957.578-2.217,1.255-5.215.777Zm5.025-.766a2.691,2.691,0,0,1,3.093-.194l-.1.194a2.369,2.369,0,0,0-2.8.189Zm3.093-.194.389.194-.487.091V7.187Zm-.1.285a2.27,2.27,0,0,0-2.222,1.068l-.194-.1a2.7,2.7,0,0,1,2.415-1.253Zm-2.222,1.068c-.583.766-1.349,1.735-4.156,2.7l-.1-.194c2.8-.874,3.579-1.93,4.058-2.607Z",
    transform: "translate(-106.685 4.788)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6195",
    "data-name": "Caminho 6195",
    d: "M125.505,10.077a9.884,9.884,0,0,0,4.539-2.223l.1.194a10.888,10.888,0,0,1-4.545,2.319Zm4.539-2.223c1.068-.771,1.838-1.251,2.995-.864v.194c-1.157-.393-1.831.189-2.894.864Z",
    transform: "translate(-105.115 4.895)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6196",
    "data-name": "Caminho 6196",
    d: "M125.509,14.457l-3.768-3.288c.866-5.6-2.513-5.021-.969-8.014.1,3.19,2.127,1.159,3.869,6.374",
    transform: "translate(-108.789 2.254)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6197",
    "data-name": "Caminho 6197",
    d: "M125.461,14.711l-3.766-3.285.19-.2,3.672,3.283Zm-3.766-3.285h0v-.1h.094Zm0-.1a7.092,7.092,0,0,0-.775-5.021l.19-.1a6.824,6.824,0,0,1,.775,5.117ZM120.92,6.31a2.392,2.392,0,0,1-.192-2.993l.192.094a2.414,2.414,0,0,0,.19,2.8Zm-.192-2.993.192-.387v.387h-.192Zm.192,0a2.3,2.3,0,0,0,1.157,2.218l-.1.2a2.579,2.579,0,0,1-1.25-2.415Zm1.157,2.218c.775.581,1.745,1.356,2.705,4.155l-.192.1c-.967-2.8-1.935-3.48-2.613-4.058Z",
    transform: "translate(-108.838 2.092)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6198",
    "data-name": "Caminho 6198",
    d: "M123.7,10.688a9.97,9.97,0,0,0-2.223-4.539l.192-.1a10.768,10.768,0,0,1,2.321,4.635Zm-2.223-4.539c-.778-1.065-1.26-1.738-.871-2.993h.192c-.389,1.155.1,1.836.871,2.9Z",
    transform: "translate(-108.715 2.254)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6199",
    "data-name": "Caminho 6199",
    d: "M123.364,9.748l3.672,3.183c-.869,5.6,2.513,5.025.969,8.019-.1-3.091-2.133-1.063-3.862-6.377",
    transform: "translate(-106.645 6.963)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6200",
    "data-name": "Caminho 6200",
    d: "M123.4,9.687l3.766,3.194-.094.194-3.768-3.189Zm3.766,3.194.1.1-.1.1-.094-.1Zm0,.194a7.171,7.171,0,0,0,.777,5.021l-.2.1a7.167,7.167,0,0,1-.768-5.218Zm.777,5.021a2.4,2.4,0,0,1,.19,3l-.19-.1a2.387,2.387,0,0,0-.2-2.8Zm.19,3-.19.386V21h.1Zm-.19-.1a2.419,2.419,0,0,0-1.159-2.218l.089-.1A2.391,2.391,0,0,1,128.137,21Zm-1.159-2.218c-.775-.485-1.742-1.263-2.705-4.159h.192a8.061,8.061,0,0,0,2.6,4.058Z",
    transform: "translate(-106.685 6.92)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6201",
    "data-name": "Caminho 6201",
    d: "M124.4,11.888a11.005,11.005,0,0,0,2.22,4.539l-.192.2a10.81,10.81,0,0,1-2.22-4.639Zm2.22,4.539c.778,1.065,1.26,1.838.871,3.094l-.192-.1c.389-1.157-.1-1.836-.871-2.8Z",
    transform: "translate(-106.04 8.492)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6202",
    "data-name": "Caminho 6202",
    d: "M124.29,9.748h2.124l-2.124,12.17-2.223-12.17h2.223v12.17",
    transform: "translate(-107.571 6.963)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6203",
    "data-name": "Caminho 6203",
    d: "M124.369,9.687h2.124v.2h-2.124Zm2.124,0h.192v.1h-.192Zm.192.106L124.47,21.961h-.293L126.4,9.793ZM124.47,21.961l-.1.581-.192-.581h.293Zm-.293,0-2.22-12.168h.286l2.227,12.168Zm-2.22-12.274h.188v.1h-.188Zm.188,0h2.224v.2h-2.224Zm2.224,0h.1v.1h-.1Zm.1,12.274h-.293V9.792h.293Z",
    transform: "translate(-107.65 6.92)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6204",
    "data-name": "Caminho 6204",
    d: "M124.29,14.861h-2.223L124.29,2.59l2.124,12.271H124.29V2.59",
    transform: "translate(-107.571 1.851)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6205",
    "data-name": "Caminho 6205",
    d: "M124.369,15.2h-2.224V15h2.224Zm-2.224,0h-.188V15.1h.188Zm-.188-.093,2.22-12.273.293.1L122.243,15.1Zm2.22-12.273.192-.579.1.579h-.293Zm.293,0L126.685,15.1H126.4l-2.22-12.173ZM126.685,15.2h-.192V15.1h.192Zm-.192,0h-2.124V15h2.124Zm-2.124,0h-.192V15.1h.192Zm-.192-12.365h.293V15.1h-.293Z",
    transform: "translate(-107.65 1.609)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6206",
    "data-name": "Caminho 6206",
    d: "M128.477,10.676v2.218l-12.271-2.218,12.271-2.227v2.227H116.206",
    transform: "translate(-111.758 6.036)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6207",
    "data-name": "Caminho 6207",
    d: "M128.822,12.974h-.293V10.756h.293Zm0,0v.1h-.2l.1-.1Zm-.2.1-12.175-2.22.1-.2,12.173,2.23Zm-12.175-2.22-.584-.093.584-.106v.2Zm0-.2,12.175-2.217.1.2-12.173,2.22Zm12.175-2.217.2-.1v.194h-.1Zm.2,2.323h-.293V8.531h.293Zm0,.093h-.1v-.093h.1Zm-.1,0H116.449v-.2H128.72Z",
    transform: "translate(-112.001 5.955)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6208",
    "data-name": "Caminho 6208",
    d: "M123.364,10.676V8.449l12.175,2.227-12.175,2.218V10.676h12.175",
    transform: "translate(-106.645 6.036)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6209",
    "data-name": "Caminho 6209",
    d: "M123.252,8.531h.293v2.227h-.293Zm0,0V8.337l.192.1v.1Zm.192-.1,12.175,2.217-.1.2L123.348,8.63Zm12.175,2.217.583.106-.583.093v-.2Zm0,.2-12.175,2.22-.1-.189,12.175-2.23Zm-12.175,2.22h-.192v-.1h.192Zm-.192-2.313h.293v2.218h-.293Zm0-.106h.192v.1h-.192Zm.192,0h12.175v.2H123.444Z",
    transform: "translate(-106.725 5.955)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6210",
    "data-name": "Caminho 6210",
    d: "M126.987,10.435l1.546,1.545-10.241,7.053,7.053-10.246,1.642,1.649-8.695,8.6",
    transform: "translate(-110.268 6.276)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6211",
    "data-name": "Caminho 6211",
    d: "M127.149,10.369l1.642,1.55-.192.194-1.546-1.546Zm1.642,1.55.1.1-.192.1v-.1Zm-.1.194-10.147,7.051-.094-.189L128.6,11.919Zm-10.147,7.051-.483.391.29-.579.1.1Zm-.194-.189,7.058-10.15.19.1-7.054,10.243Zm7.058-10.15.094-.093.1.093h-.19Zm.19,0,1.546,1.545-.1.2-1.641-1.646Zm1.546,1.545.1.1-.1.093v-.2Zm0,.2-8.6,8.6-.094-.189,8.6-8.606Z",
    transform: "translate(-110.43 6.237)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6212",
    "data-name": "Caminho 6212",
    d: "M124.048,13.37l-1.642-1.649,10.241-7.044-7.053,10.238-1.546-1.545,8.6-8.693",
    transform: "translate(-107.329 3.341)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6213",
    "data-name": "Caminho 6213",
    d: "M123.992,13.626l-1.641-1.646.19-.1,1.546,1.545Zm-1.641-1.646v-.1h.094Zm.094-.1L132.59,4.742l.1.189L122.541,11.98ZM132.59,4.742l.48-.293-.288.482-.1-.089Zm.192.189L125.73,15.174l-.192-.2L132.59,4.842ZM125.73,15.174l-.1.1-.1-.1.1-.1Zm-.192,0-1.546-1.548.1-.2,1.642,1.55Zm-1.546-1.548-.1-.093.1-.1.1.1Zm0-.2,8.6-8.587.192.089-8.695,8.695Z",
    transform: "translate(-107.368 3.178)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6214",
    "data-name": "Caminho 6214",
    d: "M126.987,13.37l-1.642,1.545L118.292,4.677l10.241,7.044-1.546,1.649-8.695-8.693",
    transform: "translate(-110.268 3.341)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6215",
    "data-name": "Caminho 6215",
    d: "M127.149,13.626,125.6,15.172l-.19-.194,1.641-1.55ZM125.6,15.172l-.1.1-.094-.1.094-.1Zm-.19,0L118.355,4.931l.194-.091L125.6,14.978ZM118.355,4.931l-.29-.482.483.293-.094.1Zm.194-.189L128.7,11.884l-.1.1L118.454,4.931ZM128.7,11.884h.192l-.1.1Zm.1.1-1.642,1.646-.1-.2,1.546-1.545Zm-1.642,1.646h-.1l.1-.093Zm-.1,0-8.6-8.695.094-.091,8.6,8.589Z",
    transform: "translate(-110.43 3.178)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6216",
    "data-name": "Caminho 6216",
    d: "M124.048,10.435l1.546-1.649,7.053,10.246L122.406,11.98l1.642-1.545,8.6,8.6",
    transform: "translate(-107.329 6.276)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6217",
    "data-name": "Caminho 6217",
    d: "M123.992,10.369l1.546-1.545.192.1-1.642,1.646Zm1.546-1.545.1-.093.1.093h-.192Zm.192,0,7.052,10.15-.192.189L125.538,8.921Zm7.052,10.15.288.581-.48-.393.1-.093Zm-.192.189-10.145-7.049.1-.2,10.145,7.056Zm-10.145-7.049-.094-.1v-.1l.094.1Zm-.094-.2,1.641-1.55.1.2-1.546,1.548Zm1.641-1.55.1-.093v.2Zm.1,0,8.695,8.606-.192.189-8.6-8.6Z",
    transform: "translate(-107.368 6.237)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6218",
    "data-name": "Caminho 6218",
    d: "M129.15,11.439a4.106,4.106,0,0,0-8.211,0,4.106,4.106,0,0,0,8.211,0",
    transform: "translate(-108.377 5.272)",
    fill: "#eac126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6219",
    "data-name": "Caminho 6219",
    d: "M129,11.521a3.6,3.6,0,0,0-1.157-2.806l.192-.192a4.237,4.237,0,0,1,1.256,3Zm-1.157-2.806a3.51,3.51,0,0,0-2.705-1.159V7.268a4.182,4.182,0,0,1,2.9,1.255Zm-2.705-1.159a3.577,3.577,0,0,0-2.8,1.159l-.19-.192a4.218,4.218,0,0,1,2.991-1.255Zm-2.8,1.159a3.574,3.574,0,0,0-1.157,2.806h-.293a4.24,4.24,0,0,1,1.26-3Zm-1.157,2.806a3.833,3.833,0,0,0,1.157,2.794l-.19.1a4.007,4.007,0,0,1-1.26-2.9Zm1.157,2.794a3.9,3.9,0,0,0,2.8,1.161v.2a4.211,4.211,0,0,1-2.991-1.255Zm2.8,1.161a3.839,3.839,0,0,0,2.705-1.161l.192.1a4.174,4.174,0,0,1-2.9,1.255Zm2.705-1.161A3.867,3.867,0,0,0,129,11.521h.291a4,4,0,0,1-1.256,2.9Z",
    transform: "translate(-108.416 5.192)",
    fill: "#292c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6220",
    "data-name": "Caminho 6220",
    d: "M126.1,9.034c-.192.293-.389-.194-1.253-.194-.965,0-1.063.487-1.255.391-.1-.1.77-.775,1.063-.775a1.892,1.892,0,0,1,1.445.578",
    transform: "translate(-106.486 6.028)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6221",
    "data-name": "Caminho 6221",
    d: "M124.755,8.958c.286.29.093.778-.194.778s-.773-.489-.485-.778",
    transform: "translate(-106.199 6.399)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6222",
    "data-name": "Caminho 6222",
    d: "M123.76,9.426c0-.482.389-.583.963-.583s.866.487,1.063.583c-.2,0-.485-.386-1.063-.386s-.574,0-.963.386",
    transform: "translate(-106.362 6.317)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6223",
    "data-name": "Caminho 6223",
    d: "M123.823,9.3c.093-.194.29.192.768.192a1.353,1.353,0,0,0,.871-.291c.192-.187-.388.482-.775.482s-.963-.286-.864-.382",
    transform: "translate(-106.325 6.545)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6224",
    "data-name": "Caminho 6224",
    d: "M124.547,9.633c.478-.192.192-.583,0-.675.1.093.389.483,0,.675",
    transform: "translate(-105.8 6.399)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6225",
    "data-name": "Caminho 6225",
    d: "M123.444,10.69c.192,0,.293-.1.581-.1s.965.485,1.349.3c-.862.384-.48.091-1.93.091h-.192",
    transform: "translate(-106.725 7.565)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6226",
    "data-name": "Caminho 6226",
    d: "M124.8,11.271a4.786,4.786,0,0,0-.482-.679,1.008,1.008,0,0,1,.482.679",
    transform: "translate(-105.96 7.566)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6227",
    "data-name": "Caminho 6227",
    d: "M123.444,11.431c.871,0,.778-.192,1.93-.667a14.5,14.5,0,0,1-1.93.382h-.192",
    transform: "translate(-106.725 7.689)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6228",
    "data-name": "Caminho 6228",
    d: "M123.364,10.729c.192,0,.293-.194.581-.194a1.332,1.332,0,0,1,.869.293c.1,0-.094-.293-.382-.293-.29-.1-.2-.578-.487-.677,0,.2.1.2.1.393s-.29.189-.386,0c.1.285-.192.285-.293.285",
    transform: "translate(-106.645 7.042)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6229",
    "data-name": "Caminho 6229",
    d: "M121.618,9.034c.192.293.382-.194,1.257-.194.96,0,1.059.487,1.257.391.093-.1-.775-.775-1.068-.775a1.887,1.887,0,0,0-1.445.578",
    transform: "translate(-107.892 6.028)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6230",
    "data-name": "Caminho 6230",
    d: "M122.3,8.958c-.29.29-.1.778.2.778s.77-.489.482-.778",
    transform: "translate(-107.51 6.399)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6231",
    "data-name": "Caminho 6231",
    d: "M123.755,9.426c0-.482-.389-.583-.96-.583-.586,0-.874.487-1.066.583.288,0,.48-.386,1.066-.386.571,0,.571,0,.96.386",
    transform: "translate(-107.812 6.317)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6232",
    "data-name": "Caminho 6232",
    d: "M123.558,9.3c-.1-.194-.3.192-.775.192a1.336,1.336,0,0,1-.871-.291c-.192-.187.389.482.778.482.482,0,.96-.286.867-.382",
    transform: "translate(-107.708 6.545)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6233",
    "data-name": "Caminho 6233",
    d: "M122.235,9.633c-.485-.192-.2-.583,0-.675-.1.093-.389.483,0,.675",
    transform: "translate(-107.641 6.399)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6234",
    "data-name": "Caminho 6234",
    d: "M124.211,10.69c-.288,0-.386-.1-.677-.1s-.965.485-1.354.3c.867.384.485.091,2.031.091h.1",
    transform: "translate(-107.491 7.565)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6235",
    "data-name": "Caminho 6235",
    d: "M122.067,11.271a7.955,7.955,0,0,0,.487-.679,1.5,1.5,0,0,0-.487.679",
    transform: "translate(-107.571 7.566)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6236",
    "data-name": "Caminho 6236",
    d: "M124.211,11.431c-.967,0-.775-.192-2.031-.667a13.444,13.444,0,0,0,2.031.382h.1",
    transform: "translate(-107.491 7.689)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6237",
    "data-name": "Caminho 6237",
    d: "M124.019,10.729c-.288,0-.386-.194-.677-.194a1.333,1.333,0,0,0-.869.293c-.1,0,.1-.293.382-.293.3-.1.2-.578.487-.677,0,.2-.1.2-.1.393s.3.189.389,0c-.093.285.194.285.386.285",
    transform: "translate(-107.299 7.042)",
    fill: "#292c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6238",
    "data-name": "Caminho 6238",
    d: "M123.509,11.379c-.192,0-.677.1,0,.1.581,0,.1-.1,0-.1",
    transform: "translate(-106.79 8.128)",
    fill: "#292c2f",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUru);
export default __webpack_public_path__ + "static/media/flag_URU.d06527eb86ff8e4af9dcc81537e89df1.svg";
export { ForwardRef as ReactComponent };